module.exports = __webpack_public_path__ + "static/img/guard_type_xz3.25a5508.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guard/guard_type_xz3.png
// module id = mJwk
// module chunks = 0